import { render } from "./QuickShopping.vue?vue&type=template&id=f4e69534"
import script from "./QuickShopping.vue?vue&type=script&lang=js"
export * from "./QuickShopping.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/clinicyas-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__